<template>
  <div style="width: 100%">
    <el-checkbox :disabled="uuid === ''" v-model="autoSave"
      >Автоматическое сохранение</el-checkbox
    >
    <el-tabs
      v-model="activeTab"
      tab-position="top"
      class="demo-tabs"
      @tab-change="onChangeTab"
    >
      <el-tab-pane label="Редактор" style="max-height: 75hv">
        <div>
          <el-form :model="form" label-width="auto" label-position="right">
            <el-form-item label="Заголовок*">
              <el-input v-model="form.title"></el-input>
            </el-form-item>
            <el-form-item label="Раздел">
              <el-autocomplete
                v-model="form.par"
                :fetch-suggestions="querySearch"
                clearable
                @select="handleSelect"
              >
                <template #default="{ item }">
                  <div class="value">{{ item }}</div>
                </template>
              </el-autocomplete>
            </el-form-item>
            <el-form-item label="Автор*">
              <el-input v-model="form.author"></el-input>
            </el-form-item>
            <el-form-item label="Статья*">
              <div style="width: 100%">
                <div ref="editorT"></div>
              </div>
            </el-form-item>
            <el-form-item style="margin-top: 50px">
              <el-button-group class="ml-4">
                <el-button type="primary" @click="onClear"
                  >Новая/Очистить</el-button
                >
                <el-button type="primary" @click="onSave">Сохранить</el-button>
                <el-button
                  type="primary"
                  tag="a"
                  :href="'https://ae.exchange/blog/' + uuid"
                  target="_blank"
                  rel="noopener noreferrer"
                  :disabled="uuid === ''"
                  >Посмотреть</el-button
                >
                <el-button
                  type="primary"
                  @click="onPublish"
                  :disabled="uuid === ''"
                  >Заявка на
                  {{ publish ? " снятие с публикации" : " публикацию" }}
                </el-button>
                <!--  <el-button
                  type="primary"
                  @click="onSave"
                  :disabled="uuid === ''"
                  >Удалить</el-button
                > -->
              </el-button-group>
            </el-form-item>
          </el-form>
        </div>
      </el-tab-pane>
      <el-tab-pane label="Архив">
        <el-table :data="blogs" style="width: 100%">
          <el-table-column
            prop="CreateAt"
            label="Дата"
            sortable
            :formatter="dateFormater"
            width="220"
          />
          <el-table-column
            prop="Title"
            label="Заголовок"
            sortable
            width="420"
          />
          <el-table-column prop="Author" label="Автор" width="120" />
          <el-table-column fixed="right" label="" min-width="120">
            <template #default="scope">
              <el-button
                type="primary"
                size="small"
                @click.prevent="onEditArticle(scope.row)"
                :icon="Edit"
              />
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import {
  ElButton,
  ElForm,
  ElFormItem,
  ElInput,
  ElMessage,
  ElAutocomplete,
} from "element-plus";
import { Edit } from "@element-plus/icons-vue";
import {
  defineComponent,
  reactive,
  ref,
  onMounted,
  watch,
  useTemplateRef,
} from "vue";

import { useMyStorage } from "@/store/global";
import axios from "axios";
import { MD5 } from "crypto-js";
import "@toast-ui/editor/dist/toastui-editor.css";

import Editor from "@toast-ui/editor";
import tableMergedCell from "@toast-ui/editor-plugin-table-merged-cell";
import uml from "@toast-ui/editor-plugin-uml";

export default defineComponent({
  name: "BlogToastComponent",
  components: {
    ElForm,
    ElFormItem,
    ElInput,
    ElButton,
    ElAutocomplete,
  },
  setup() {
    const blogs = ref([]);
    const editorToast = useTemplateRef("editorT");
    let editor = null;
    const form = reactive({
      title: "",
      text: "",
      author: "",
      par: "",
    });
    const publish = ref(false);
    const autoSave = ref(false);
    const pars = ref([]);
    const oldMD5 = ref("");
    const uuid = ref("");
    const store = useMyStorage();
    const activeTab = ref("0");
    const onEditorLoad = () => {
      console.log(editorToast.value);
      console.log("===========================================");
    };
    onMounted(() => {
      console.log(editorToast.value);
      console.log("---------------------------------------------------");
      if (editorToast.value) {
        editor = new Editor({
          el: editorToast.value,
          height: "500px",
          initialEditType: "wysiwyg",
          plugins: [tableMergedCell, uml],

          events: {
            /* load: (editor: any) => {
                        }, */
            change:
              (/* param: { source: SourceType | 'viewer'; data: MouseEvent } */) => {
                //  const value = editor.getMarkdown();
              },
          },
        });
      }
      LoadPars();
    });
    watch(
      () => editorToast.value,
      (v) => {
        console.log(v);

        if (v !== undefined && v !== null) {
          console.log(v);
          /*  if (v.value.editor) {
            console.log(editorToast.value.editor.value);
          }*/
          console.log("000000000000000000000000000000000000000000000000000000");
          /*const quill = v.getQuill();
          console.log(quill);*/
          //  quill.getModule("toolbar").addHandler("video", videoHandler);
        }
      }
    );

    const LoadPars = () => {
      axios.get(store.ServerUrl + "/blog/pars").then(function (res) {
        console.log(res);
        if (res.status === 200) {
          pars.value = res.data.Pars;
        }
      });
    };
    const onChangeTab = (name) => {
      if (name === "1") {
        LoadPars();
        axios.get(store.ServerUrl + "/blog/articles").then(function (res) {
          console.log(res);
          if (res.status === 200) {
            let dt = res.data;
            console.log(dt);
            if (dt.length > 0) {
              dt.sort((a, b) => {
                const da = new Date(a.CreateAt);
                const db = new Date(b.CreateAt);
                if (da.getUTCMilliseconds() < db.getUTCMilliseconds()) {
                  return 1;
                } else if (da.getUTCMilliseconds() > db.getUTCMilliseconds()) {
                  return -1;
                }
                // a === b
                return 0;
              });
              console.log(dt);
            }
            blogs.value = dt;
          }
        });
      }
    };
    const StartTimer = () => {
      setInterval(() => {
        if (
          autoSave.value == true &&
          uuid.value !== "" &&
          editorToast.value !== null
        ) {
          checkChange();
          //onSave()
        }
      }, 60000);
    };
    const checkChange = () => {
      console.log(editorToast.value);
      if (editorToast.value === null) {
        autoSave.value = false;
      }
      let data = {
        Title: form.title.trim(),
        Author: form.author.trim(),
        Par: form.par.trim(),
        Content: editor.getHTML(),
      };
      const md = MD5(JSON.stringify(data));

      if (md.toString() !== oldMD5.value) {
        onSave();
        oldMD5.value = md.toString();
      }
    };
    const onPublish = () => {
      let data = {
        Uid: uuid.value,
        Published: !publish.value,
      };
      console.log(data);
      axios
        .post(store.ServerUrl + "/blog/my/publish", data)
        .then(function (response) {
          console.log(response);
          if (response.status === 200) {
            console.log(response.data);
            if (response.data.code === 0) {
              ElMessage({
                type: "success",
                message: "Заяка отправлена",
              });
              publish.value = response.data.data.Published;
            }
          }
        })
        .catch(function (err) {
          console.log(err);
          ElMessage({
            type: "error",
            message: err,
          });
        });
    };
    const querySearch = (queryString, cb) => {
      console.log(pars.value);
      console.log(queryString);
      const results = queryString
        ? pars.value.filter((par) => {
            console.log(par);
            return par.toLowerCase().indexOf(queryString.toLowerCase()) > -1;
          })
        : pars.value;
      // call callback function to return suggestions
      cb(results);
    };
    const handleSelect = (item) => {
      form.par = item;
      console.log(item);
    };
    const onEditArticle = (row) => {
      LoadPars();

      axios.get(store.ServerUrl + "/blog/" + row.Uuid).then(function (res) {
        console.log(res);
        if (res.status === 200) {
          const article2 = res.data;
          form.author = row.Author;
          form.title = row.Title;
          form.par = row.Par;
          publish.value = row.Published;
          form.text = article2;
          editor.reset();
          editor.setHTML(article2.Content);

          // editor.value.editor.setHtml(article2.Content)
          form.par = row.Par;
          uuid.value = row.Uuid;
        }
      });

      autoSave.value = true;
      activeTab.value = "0";
    };
    const onClear = () => {
      form.author = "";
      form.text = "";
      form.title = "";
      uuid.value = "";
      form.par = "";
      editor.reset("", true);
      autoSave.value = false;
      LoadPars();
    };

    const onSave = () => {
      if (
        form.title.trim() === "" ||
        form.author.trim() === "" ||
        editor.getHTML() === ""
      ) {
        ElMessage({
          type: "error",
          message: "Перед сохранением нужно обязательно заполнить все поля ",
        });
        return;
      }
      // let token = store.token.value;
      let data = {
        Title: form.title.trim(),
        Author: form.author.trim(),
        Content: editor.getHTML(),
        Par: form.par.trim(),
      };
      if (uuid.value !== "") {
        data.Uuid = uuid.value;
      }
      // console.log(token);
      //   axios.defaults.headers.common["Authorization"] = token;
      axios
        .post(store.ServerUrl + "/blog/save", data)
        .then(function (response) {
          console.log(response);
          if (response.status === 200) {
            console.log(response.data);
            if (response.data.code === 0) {
              ElMessage({
                type: "success",
                message: "Статья сохранена ",
              });
              uuid.value = response.data.data.Uuid;
              autoSave.value = true;
            }
          }
        })
        .catch(function (err) {
          ElMessage({
            type: "error",
            message: err,
          });
        });
    };
    const dateFormater = (row) => {
      const arr = row.CreateAt.split("T");
      const arr2 = arr[0].split("-");
      const arr3 = arr[1].split(".");

      return arr2[2] + "." + arr2[1] + "." + arr2[0] + " " + arr3[0];
    };
    const editorOptions = {};
    StartTimer();
    return {
      onSave,
      onClear,
      onChangeTab,
      onEditArticle,
      onPublish,
      uuid,
      form,
      store,
      editorToast,
      blogs,
      autoSave,
      activeTab,
      publish,
      Edit,
      querySearch,
      handleSelect,
      editorOptions,
      onEditorLoad,
      dateFormater,
    };
  },
});
</script>
<style lang="scss" scoped>
.ql-editor {
  img {
    width: 100% !important;
  }
}
.ql-tooltip {
  margin-left: 100px !important;
}
</style>
